import { useQuery } from '@apollo/client';

import type {
  Exact,
  InputMaybe,
  Scalars,
} from '@xing-com/crate-common-graphql-types';

import type { CompaniesByIndustryQuery } from '../../graphql/queries/companies-by-industry.gql-types';
import { CompaniesByIndustryDocument } from '../../graphql/queries/companies-by-industry.gql-types';

type CompaniesByIndustriesProps = {
  limit: number;
  offset: number;
  id: string;
  skip?: boolean;
  rotate?: boolean;
};

export const useCompaniesByIndustry = ({
  limit = 4,
  offset = 0,
  id,
  skip = false,
  rotate = false,
}: CompaniesByIndustriesProps) => {
  const response = useQuery<
    CompaniesByIndustryQuery,
    Exact<{
      id: Scalars['ID']['input'];
      limit?: InputMaybe<Scalars['Int']['input']>;
      offset?: InputMaybe<Scalars['Int']['input']>;
      rotate?: InputMaybe<Scalars['Boolean']['input']>;
    }>
  >(CompaniesByIndustryDocument, {
    skip,
    variables: { limit, offset, id, rotate },
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return response;
};
